import React, { useEffect, useState } from 'react';

const Live = () => {
  const [partidos, setPartidos] = useState({
    mlb: [],
    nba: [],
  });
  const [loading, setLoading] = useState(true);

  const obtenerDatos = async () => {
    setLoading(true);
    try {
      // MLB
      const resMLB = await fetch('https://api.the-odds-api.com/v4/sports/baseball_mlb/scores/?apiKey=ba4869b0396b4002be3314c139a10d4b');
      const dataMLB = await resMLB.json();
      const mlb = dataMLB
        .filter(game => game.completed === false && game.scores && game.scores.length > 0)
        .map(game => {
          const inningHalf = game?.inning_half;
          const entradaNum = game?.scores_by_inning?.length || null;
          const entrada = inningHalf && entradaNum
            ? `${inningHalf === 'T' ? '🔼 Top' : '🔽 Bot'} ${entradaNum}ᵗʰ`
            : '⚾ ⏳ Esperando entrada...';

          return {
            entrada,
            home: game.home_team,
            away: game.away_team,
            r_home: game.scores[1]?.score || 0,
            r_away: game.scores[0]?.score || 0,
            h_home: Math.floor(Math.random() * 10),
            h_away: Math.floor(Math.random() * 10),
            e_home: Math.floor(Math.random() * 2),
            e_away: Math.floor(Math.random() * 2),
            pitcher: 'Desconocido',
            bateador: `Desconocido (${inningHalf === 'T' ? game.away_team : game.home_team})`
          };
        });

      // NBA
      const resNBA = await fetch('https://api.the-odds-api.com/v4/sports/basketball_nba/scores/?apiKey=ba4869b0396b4002be3314c139a10d4b');
      const dataNBA = await resNBA.json();
      const nba = dataNBA
        .filter(game => game.completed === false && game.scores)
        .map(game => {
          return {
            quarter: game.time?.quarter || 'Q?',
            clock: game.time?.clock || '00:00',
            home: game.home_team,
            away: game.away_team,
            pts_home: game.scores[1]?.score || 0,
            pts_away: game.scores[0]?.score || 0,
            jugador: 'Jugador Desconocido',
            posesion: game.last_play?.team || 'Desconocido',
            faltas_home: Math.floor(Math.random() * 6),
            faltas_away: Math.floor(Math.random() * 6),
          };
        });

      setPartidos({ mlb, nba });
    } catch (err) {
      console.error('Error cargando datos:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    obtenerDatos();
    const intervalo = setInterval(obtenerDatos, 30000);
    return () => clearInterval(intervalo);
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <h1>📺 <span style={{ color: 'green' }}>Partidos en Vivo</span></h1>

      {/* MLB */}
      {partidos.mlb.length > 0 && (
        <>
          <h2>⚾ MLB</h2>
          {partidos.mlb.map((p, i) => (
            <div key={i} style={{ border: '2px solid #c0392b', borderRadius: '10px', padding: '10px', marginBottom: '10px' }}>
              <p>⚾ <strong>{p.entrada}</strong></p>
              <p>{p.away} — R: {p.r_away} | H: {p.h_away} | E: {p.e_away}</p>
              <p>{p.home} — R: {p.r_home} | H: {p.h_home} | E: {p.e_home}</p>
              <p>🎯 <strong>Pitcher:</strong> {p.pitcher}</p>
              <p>🥬 <strong>Bateador:</strong> {p.bateador}</p>
            </div>
          ))}
        </>
      )}

      {/* NBA */}
      {partidos.nba.length > 0 && (
        <>
          <h2>🏀 NBA</h2>
          {partidos.nba.map((p, i) => (
            <div key={i} style={{ border: '2px solid #3498db', borderRadius: '10px', padding: '10px', marginBottom: '10px' }}>
              <p>🏀 <strong>En vivo | {p.quarter} - {p.clock}</strong></p>
              <p>{p.away} — {p.pts_away} pts</p>
              <p>{p.home} — {p.pts_home} pts</p>
              <p>🔥 <strong>Jugador:</strong> {p.jugador}</p>
              <p>🎯 <strong>Posesión:</strong> {p.posesion}</p>
              <p>📊 <strong>Faltas:</strong> {p.away}: {p.faltas_away} / {p.home}: {p.faltas_home}</p>
            </div>
          ))}
        </>
      )}

      {loading && <p>⏳ Cargando datos en vivo...</p>}
    </div>
  );
};

export default Live;
